import React from 'react';
import {apiRoutePrefix, RouteComponent} from '../../../RouteComponent';
import {Box, Divider} from '@material-ui/core';
import ObjectHeader from '../ObjectHeader';
import ObjectDefinition from '../ObjectDefinition';
import {jsonObject, shipmentAttributes, shipmentHeader} from '../../data/shipments/shipment';
import RequestDefinition from '../RequestDefinition';

export default new RouteComponent(`${apiRoutePrefix}/shipments`, () => {
    return (
        <div>
            <ObjectHeader data={ shipmentHeader }/>

            <Box mb={ 3 }>
                <Divider/>
            </Box>

            <ObjectDefinition data={ {
                title: 'The shipment object',
                attributes: shipmentAttributes,
                jsonObject: jsonObject
            } }/>

            {
                shipmentHeader.endpoints.map(data => (
                    <>
                        <Box mb={3}>
                            <Divider/>
                        </Box>
                        <RequestDefinition {...data} />
                    </>
                ))
            }
        </div>
    );
});
